import {useState} from 'react'
import {ListViewProvider} from '../core/ListViewProvider'
import {QueryRequestProvider} from '../core/QueryRequestProvider'
import {ColumnVisibilityProvider} from '../core/ColumnVisibilityProvider'
import {TasksByUserTable} from './table/TasksByUserTable'
import {QUERIES} from '../../../../_metronic/helpers'
import {QueryResponseProvider, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {TaskModal} from '../../../../_metronic/partials/modals/task/TaskModal'
import {TasksByUserListHeader} from './header/TasksByUserListHeader'
import {TasksByUserKanban} from './kanban/TasksByUserKanban'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {useParams, useSearchParams} from 'react-router-dom'
import {getUserById} from '../../user/components/users-list/core/_requests'
import {useAuth} from '../../auth'

const TasksByUserList = () => {
  const intl = useIntl()
  const {userId} = useParams()
  const isLoading = useQueryResponseLoading()
  const [showModalStepper, setShowModalStepper] = useState<boolean>(false)
  const {currentUser} = useAuth()
  const [searchParams] = useSearchParams()

  const {data: user} = useQuery(
    `${QUERIES.USERS_LIST}-USER-${userId}`,
    () => {
      return getUserById(parseInt(userId!))
    },
    {
      onSuccess: (response) => {
        if (response.users.instance_id != currentUser?.instance_id) {
          window.location.href = `../404`
        }
      },
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  )

  return (
    <>
      <PageTitle>
        {intl.formatMessage({id: 'MENU.TASKS.BY_USER'}, {item: user?.users.name})}
      </PageTitle>

      <div className='dash-section tasksbyuser-page'>
        <TasksByUserListHeader />
        <div className={`${isLoading && 'pe-none'} tab-content`}>
          {searchParams.get('mode') != 'kanban' ? <TasksByUserTable /> : <TasksByUserKanban />}
        </div>
      </div>
      <TaskModal show={showModalStepper} handleClose={() => setShowModalStepper(false)} />
    </>
  )
}

const TasksByUserIdListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ColumnVisibilityProvider>
          <TasksByUserList />
        </ColumnVisibilityProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {TasksByUserIdListWrapper}
